import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay, Pagination } from 'swiper/modules';
import { Button } from '../component/Button';
import { useTranslation } from 'react-i18next';

const backgroundImages = [
    'asset-rentcar/2-hiace-commuter-silver-metallic.png',
    'asset-rentcar/2-hiace-premio-white.png',
    'asset-rentcar/alphard-hitam-2023.png',
    'asset-rentcar/nenix-depan-slider.png'
];

export default function HeroSection() {
    const { t, i18n } = useTranslation();
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="relative h-screen w-full text-white overflow-hidden bg-gradient-to-r from-[#347433] to-[#FFC107]">
            <div className="relative z-10 flex flex-col-reverse md:flex-row h-full">

                {/* LEFT CONTENT */}
                <div className="relative flex flex-col justify-center px-8 md:px-16 lg:px-24 w-full md:w-1/2 space-y-6 py-8 md:py-0">
                    <h2 className="text-3xl md:text-5xl font-extrabold leading-tight">
                        {t('rent_luxury_car')} <br></br> <b className="text-yellow-400">{t('without_hassle')}</b>
                    </h2>
                    <p className="text-base md:text-lg text-gray-300 max-w-md">
                        {t('desc_hero_section')}
                    </p>
                    <div className="space-x-4">
                        <Button onClick={() => scrollToSection("unit")}>{t('view_unit')}</Button>
                        <Button variant="inverse" onClick={() => scrollToSection("kontak")}>
                            {t('contact_us')}
                        </Button>
                    </div>
                </div>

                {/* RIGHT SWIPER IMAGE */}
                <div className="relative w-full md:w-1/2 h-[50vh] md:h-full">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        autoplay={{ delay: 4000 }}
                        loop
                        pagination={{
                            clickable: true,
                            bulletClass: "swiper-pagination-bullet !bg-white/50",
                            bulletActiveClass: "swiper-pagination-bullet-active !bg-yellow-400"
                        }}
                        className="h-full w-full"
                    >
                        {backgroundImages.map((img, i) => (
                            <SwiperSlide key={i}>
                                <div className="flex items-center justify-center h-full">
                                    <img
                                        src={img}
                                        alt={`Luxury Car ${i + 1}`}
                                        className="max-h-full max-w-full object-contain"
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
            <a className='text-transparent' href="https://softwaremedan.com" target="_blank" rel="dofollow">Jasa Pembuatan Software Profesional Medan</a>
        </div>
    );
}
